module.exports = __webpack_public_path__ + "aa173a411c379683520fa80858c99514.svg";